import React from 'react';
import FontFamilySelectField from './FontFamilySelectField';
import { siteHasCustomFont, getSiteDefaultFont } from '../utils/defaults';

export default function ButtonTypographyFields({ props, setProp, siteTypography }) {
  const hasSiteFont = siteHasCustomFont(siteTypography);

  return (
    <div className="rounded-lg border border-border p-3 space-y-3 bg-muted/10">
      <p className="text-xs font-semibold text-foreground">Police du libellé</p>
      {hasSiteFont ? (
        <label className="flex items-start gap-3 cursor-pointer">
          <input
            type="checkbox"
            className="mt-0.5"
            checked={props.inheritSiteButtonFont !== false}
            onChange={(e) => setProp('inheritSiteButtonFont', e.target.checked)}
          />
          <span className="text-sm">
            <span className="font-medium text-foreground block">Hériter de la police par défaut du site</span>
            <span className="text-xs text-muted-foreground">
              {(() => {
                const def = getSiteDefaultFont(siteTypography);
                return def
                  ? `Utilise « ${def.label || def.fontFamily} ».`
                  : 'Police définie dans la configuration du site.';
              })()}
            </span>
          </span>
        </label>
      ) : null}
      {(!hasSiteFont || props.inheritSiteButtonFont === false) ? (
        <FontFamilySelectField
          label="Police du bouton"
          value={props.buttonFontFamily || 'system'}
          onChange={(v) => setProp('buttonFontFamily', v)}
          siteTypography={siteTypography}
          includeSiteDefault={hasSiteFont}
        />
      ) : null}
    </div>
  );
}
